
import { createElement } from "react";
import React from "react";
import { defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ofArray, singleton, fold } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ModalTitle } from "./Text.js";
import { TextButton } from "./Button.js";
import Delete_1 from "../../public/assets/icons/Delete_1.svg";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Sheet } from "react-modal-sheet";

export function ModalSheet(props) {
    let children_3, props_3, children_2, props_1, children, elems, sheet, props_2, sheet_1, sheet_2, sheet_3;
    const props_5 = ofArray([["style", {
        zIndex: defaultArg(props.ZIndex, 20),
    }], ["isOpen", props.IsModalOpen], ["onClose", props.OnClose], ["detent", "default"], ["className", fold((a, b) => concat(a, " ", ...b), "", singleton("print:!absolute"))], (children_3 = ofArray([(props_3 = singleton((children_2 = ofArray([(props_1 = singleton((children = singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton_1("flex"), delay(() => append(singleton_1("flex-row"), delay(() => append(singleton_1("items-center"), delay(() => append(singleton_1("m-4"), delay(() => append(singleton_1("gap-4"), delay(() => append((props.Title == null) ? singleton_1("justify-end") : empty(), delay(() => singleton_1("print:hidden"))))))))))))))))], (elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = props.Title, (matchValue == null) ? (empty()) : singleton_1(createElement(ModalTitle, {
            Text: matchValue,
        }))), delay(() => append(props.Controls, delay(() => singleton_1(createElement(TextButton, {
            ComponentState: "enabled",
            Icon: Delete_1(),
            Label: "",
            OnClick: () => {
                props.OnClose();
            },
            TestId: props.CloseButtonTestId,
            Variant: "default",
        }))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), ["children", reactApi_1.Children.toArray(children)])), (sheet = Sheet, reactApi_1.createElement(sheet.Header, createObj(props_1)))), (props_2 = singleton(["children", reactApi_1.Children.toArray([props.Content])]), (sheet_1 = Sheet, reactApi_1.createElement(sheet_1.Content, createObj(props_2))))]), ["children", reactApi_1.Children.toArray(children_2)])), (sheet_2 = Sheet, reactApi_1.createElement(sheet_2.Container, createObj(props_3)))), (sheet_3 = Sheet, reactApi_1.createElement(sheet_3.Backdrop, {
        onTap: props.OnClose,
    }))]), ["children", reactApi_1.Children.toArray(children_3)])]);
    return reactApi_1.createElement(Sheet, createObj(props_5));
}

